import { SHARED_AUTHORITY, SHARED_SSO } from './environment.shared';

export const environment = {
	production: false,
	enableServiceWorker: false,
	apiUrl: 'https://uat.gtlcapi.ca/rest/gtlc-cms_uat',
	redirectUrl: 'https://uat.staff.gtlc.ca',
	uploadUrl: 'https://uat.gtlcapi.ca/uploads',
	msal: {
		clientId: SHARED_SSO.msal.clientId,
		authority: SHARED_AUTHORITY,
		redirectUri: 'https://uat.staff.gtlc.ca',
	},
	wsServer: 'wss://uat.gtlcapi.ca/ws/websocket',
};
